"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Action = _interopRequireDefault(require("../model/Action"));

var _ActionsResponse = _interopRequireDefault(require("../model/ActionsResponse"));

var _CreateActionResponse = _interopRequireDefault(require("../model/CreateActionResponse"));

var _DeleteActionResponse = _interopRequireDefault(require("../model/DeleteActionResponse"));

var _GetActionResponse = _interopRequireDefault(require("../model/GetActionResponse"));

var _HTTPBadRequestError = _interopRequireDefault(require("../model/HTTPBadRequestError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _LinksResponse = _interopRequireDefault(require("../model/LinksResponse"));

var _PatchAction = _interopRequireDefault(require("../model/PatchAction"));

var _PatchActionResponse = _interopRequireDefault(require("../model/PatchActionResponse"));

var _SendTestAction = _interopRequireDefault(require("../model/SendTestAction"));

var _SendTestActionResponse = _interopRequireDefault(require("../model/SendTestActionResponse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* Action service.
* @module api/ActionApi
* @version integration550
*/
var ActionApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ActionApi. 
  * @alias module:api/ActionApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ActionApi(apiClient) {
    _classCallCheck(this, ActionApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the createAction operation.
   * @callback module:api/ActionApi~createActionCallback
   * @param {String} error Error message, if any.
   * @param {module:model/CreateActionResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create an action
   * @param {String} workflowId 
   * @param {module:model/Action} action 
   * @param {Object} opts Optional parameters
   * @param {Number} opts.accountId 
   * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
   * @param {module:api/ActionApi~createActionCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/CreateActionResponse}
   */


  _createClass(ActionApi, [{
    key: "createAction",
    value: function createAction(workflowId, action, opts, callback) {
      opts = opts || {};
      var postBody = action; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling createAction");
      } // verify the required parameter 'action' is set


      if (action === undefined || action === null) {
        throw new Error("Missing the required parameter 'action' when calling createAction");
      }

      var pathParams = {
        'workflow_id': workflowId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CreateActionResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteAction operation.
     * @callback module:api/ActionApi~deleteActionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeleteActionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete an action
     * @param {String} actionId 
     * @param {String} workflowId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
     * @param {module:api/ActionApi~deleteActionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeleteActionResponse}
     */

  }, {
    key: "deleteAction",
    value: function deleteAction(actionId, workflowId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'actionId' is set

      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling deleteAction");
      } // verify the required parameter 'workflowId' is set


      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling deleteAction");
      }

      var pathParams = {
        'action_id': actionId,
        'workflow_id': workflowId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DeleteActionResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getAction operation.
     * @callback module:api/ActionApi~getActionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetActionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get an action
     * @param {String} workflowId 
     * @param {String} actionId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
     * @param {module:api/ActionApi~getActionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/GetActionResponse}
     */

  }, {
    key: "getAction",
    value: function getAction(workflowId, actionId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling getAction");
      } // verify the required parameter 'actionId' is set


      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling getAction");
      }

      var pathParams = {
        'workflow_id': workflowId,
        'action_id': actionId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _GetActionResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listActionLinks operation.
     * @callback module:api/ActionApi~listActionLinksCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LinksResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show action links
     * @param {String} actionId 
     * @param {String} workflowId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {module:api/ActionApi~listActionLinksCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LinksResponse}
     */

  }, {
    key: "listActionLinks",
    value: function listActionLinks(actionId, workflowId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'actionId' is set

      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling listActionLinks");
      } // verify the required parameter 'workflowId' is set


      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling listActionLinks");
      }

      var pathParams = {
        'action_id': actionId,
        'workflow_id': workflowId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _LinksResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}/links', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listActions operation.
     * @callback module:api/ActionApi~listActionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List actions
     * @param {String} workflowId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {Number} opts.accountId 
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `name`   - `created_on`
     * @param {module:api/ActionApi~listActionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActionsResponse}
     */

  }, {
    key: "listActions",
    value: function listActions(workflowId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling listActions");
      }

      var pathParams = {
        'workflow_id': workflowId
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'account_id': opts['accountId'],
        'sort': opts['sort']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionsResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the patchAction operation.
     * @callback module:api/ActionApi~patchActionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PatchActionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an action
     * @param {String} actionId 
     * @param {String} workflowId 
     * @param {module:model/PatchAction} patchAction 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
     * @param {module:api/ActionApi~patchActionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PatchActionResponse}
     */

  }, {
    key: "patchAction",
    value: function patchAction(actionId, workflowId, _patchAction, opts, callback) {
      opts = opts || {};
      var postBody = _patchAction; // verify the required parameter 'actionId' is set

      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling patchAction");
      } // verify the required parameter 'workflowId' is set


      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling patchAction");
      } // verify the required parameter 'patchAction' is set


      if (_patchAction === undefined || _patchAction === null) {
        throw new Error("Missing the required parameter 'patchAction' when calling patchAction");
      }

      var pathParams = {
        'action_id': actionId,
        'workflow_id': workflowId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatchActionResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the renderAction operation.
     * @callback module:api/ActionApi~renderActionCallback
     * @param {String} error Error message, if any.
     * @param {String} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Render an action
     * @param {String} workflowId 
     * @param {String} actionId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
     * @param {module:api/ActionApi~renderActionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link String}
     */

  }, {
    key: "renderAction",
    value: function renderAction(workflowId, actionId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling renderAction");
      } // verify the required parameter 'actionId' is set


      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling renderAction");
      }

      var pathParams = {
        'workflow_id': workflowId,
        'action_id': actionId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['text/html', 'application/json'];
      var returnType = 'String';
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}/render', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the sendTestAction operation.
     * @callback module:api/ActionApi~sendTestActionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SendTestActionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send a test of an action
     * @param {String} workflowId 
     * @param {String} actionId 
     * @param {module:model/SendTestAction} sendTestAction 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.lockKey Locking key, preventing other users from modifying this workflow for a short period.
     * @param {module:api/ActionApi~sendTestActionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SendTestActionResponse}
     */

  }, {
    key: "sendTestAction",
    value: function sendTestAction(workflowId, actionId, _sendTestAction, opts, callback) {
      opts = opts || {};
      var postBody = _sendTestAction; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling sendTestAction");
      } // verify the required parameter 'actionId' is set


      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling sendTestAction");
      } // verify the required parameter 'sendTestAction' is set


      if (_sendTestAction === undefined || _sendTestAction === null) {
        throw new Error("Missing the required parameter 'sendTestAction' when calling sendTestAction");
      }

      var pathParams = {
        'workflow_id': workflowId,
        'action_id': actionId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'lock_key': opts['lockKey']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SendTestActionResponse["default"];
      return this.apiClient.callApi('/workflows/{workflow_id}/actions/{action_id}/send-test', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return ActionApi;
}();

exports["default"] = ActionApi;